import React, { useState, useEffect } from "react";
import Box from '@mui/material/Box';
import { Autocomplete, Divider, FormControl, TextField, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import Grid from '@mui/material/Grid2';
import CircumIcon from "@klarr-agency/circum-icons-react";
import { useNavigate } from "react-router-dom";
import { Bar } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import Toastmessage from "../../components/Toast";
import { logout } from "../../features/auth/AuthSlice";
import { authApi } from "../../api/api";
import { useDispatch, useSelector } from "react-redux";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);


const columns = [
    {
        field: 'metric', headerName: '', width: 120,
        renderCell: (params) => (
            <span style={{ fontWeight: '500', color: 'var(--primary-color)' }}>{params.value}</span>
        ),
        sortable: false,
        filterable: false,
        disableColumnMenu: true, // Disable column menu
    },
    { field: 'January', headerName: 'January', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'February', headerName: 'February', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'March', headerName: 'March', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'April', headerName: 'April', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'May', headerName: 'May', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'June', headerName: 'June', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'July', headerName: 'July', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'August', headerName: 'August', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'September', headerName: 'September', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'October', headerName: 'October', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'November', headerName: 'November', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    { field: 'December', headerName: 'December', flex: 1, sortable: false, filterable: false, disableColumnMenu: true },
    {
        field: 'Cumulative', headerName: 'Cumulative', flex: 1.5,
        renderCell: (params) => (
            <span style={{ fontWeight: 'bold' }}>{params.value}</span>
        ),
        sortable: false,
        filterable: false,
        disableColumnMenu: true, // Disable column menu
    },
];


export default function MonthlyScoreCard() {

    const token = useSelector((state) => state.auth.token); // Get the token from Redux
    const userID = useSelector((state) => state.auth.id); // Get the userID from Redux
    const [barChart, setbarChart] = useState([])
    const [locationOption, setLocationOptions] = useState([]);
    const [locationName, setLocationName] = useState(null);
    const [monthYear, setMonthYear] = useState('');
    const [monthYearOption, setMonthYearOption] = useState([]);
    const [data, setData] = useState([])
    const [year, setYear] = useState("2025")
    const dispatch = useDispatch()
    const navigate = useNavigate();

    useEffect(() => {
       
        fetchLocation()
        fetcYearMonth()
    }, [])

      useEffect(() => {
        if (monthYear) {
            fetcManageReport()
        }
      }, [monthYear,locationName])


    // Define fetchLocations separately to reuse it
    const fetcYearMonth = async () => {
        const input_token = 'TIMESHEET_MONTH_YEAR'; // Replace with your actual token
        const apiUrl = 'get_month_year'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setMonthYearOption(data.month_year);
                setMonthYear(data.month_year?.[0])
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };


    // Define fetchLocations separately to reuse it
    const fetchLocation = async () => {
        const input_token = 'LOCATIONS'; // Replace with your actual token
        const apiUrl = 'list_of_locations'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID
        };

        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                const statesArray = data.locations.map(location => ({
                    id: location.id,
                    locationname: location.location_name, // Match `getOptionLabel`
                }));

                setLocationOptions(statesArray);
                setLocationName(statesArray?.[0])

            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };

    // Define fetchLocations separately to reuse it
    const fetcManageReport = async () => {
        const input_token = 'MONTHLY_SCORECARD'; // Replace with your actual token
        const apiUrl = 'monthly_scorecard'; // Replace with the actual API endpoint

        const dataInput = {
            login_user_id: userID,
            year: monthYear,
            location: locationName?.id,

        };
        try {
            const data = await authApi(input_token, dataInput, apiUrl, token);

            if (data && data.success) {
                setData(data?.yearly_report)
                const backgroundColors = ['#962DFF', '#4A3AFF', '#E0C6F5'];
                const borderRadius = 200;
                const barchart = data?.total_summary?.map((item, index) => ({
                    ...item,
                    backgroundColor: backgroundColors[index % backgroundColors.length],
                    borderRadius: borderRadius,
                }));
                setbarChart(barchart)
            } else if (data && data.message === 'Token has expired') {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else if (data === undefined) {
                await Toastmessage('No response from server', false);
            } else {
                await Toastmessage(data?.message || 'An error occurred', false);
            }

        } catch (error) {
            console.error("Error fetching data:", error);
            if (error.response && error.response.status === 401) {
                dispatch(logout());
                localStorage.removeItem('token');
                await Toastmessage('Session expired. Redirecting to login...', false);
                navigate('/login');
            } else {
                await Toastmessage('Something went wrong', false);
            }
        }
    };



    const barData = {
        labels: [
            'January', 'February', 'March', 'April', 'May', 'June',
            'July', 'August', 'September', 'October', 'November', 'December'
        ],
        datasets: barChart
    };

    const barOptions = {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
            legend: {
                position: 'right',
            },
            title: {
                display: false,
                text: 'Monthly Performance Comparison',
            },
        },
        layout: {
            padding: {
                right: 150, // Adjust this value if needed to ensure the legend fits
            },
        },
        scales: {
            x: {
                barPercentage: 0, // Adjust this value to increase or decrease the gap
                categoryPercentage: 0, // Adjust this value to increase or decrease the gap
            },
        },
    };


    return (
        <Box className="scorecard-container">
            <Box
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                marginBottom='20px'
                backgroundColor='var(--theme-bg-light)'
                padding={2}
                borderRadius={1}
            >
                {/* Left Section */}
                <Box display="flex" alignItems="center">
                    <CircumIcon name="percent" style={{ marginRight: 8, fontSize: '15px', color: 'var(--icon-color)' }} />
                    <Typography fontSize={15} color="var(--text-color)">
                        Legal Team Monthly Scorecard
                    </Typography>
                </Box>

                {/* Right Section */}
            </Box>

            <Grid container spacing={4} sx={{ px: 2 }}>
                <Grid size={{md: 2, xs: 6 }}>
                    <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Location</Typography>
                    <FormControl fullWidth>
                        <Autocomplete
                            options={locationOption}
                            getOptionLabel={(option) => option.locationname}
                            value={locationName}
                            onChange={(event, newValue) => setLocationName(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select location"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                                    }}
                                />
                            )}
                            sx={{ width: '100%' }}
                        />
                    </FormControl>
                </Grid>

                <Grid size={{md: 2, xs: 6 }}>
                    <Typography sx={{ mb: 1, fontWeight: '500', color: '#595A63' }}>Month & Year</Typography>
                    <FormControl fullWidth>

                        <Autocomplete
                            options={monthYearOption} // Array of month-year strings
                            value={monthYear} // Value is a string
                            onChange={(event, newValue) => setMonthYear(newValue)}
                            renderInput={(params) => (
                                <TextField
                                    {...params}
                                    placeholder="Select month & year"
                                    variant="outlined"
                                    InputProps={{
                                        ...params.InputProps,
                                        sx: { borderRadius: '8px', backgroundColor: 'var(--theme-bg-light)' },
                                    }}
                                />
                            )}
                            sx={{ width: '100%' }}
                        />
                    </FormControl>
                </Grid>
            </Grid>

            <Box sx={{  p: 2 }}>

                <Grid container spacing={4} >
                    <Grid item size={12}>
                        <Box
                            sx={{
                                backgroundColor: 'var(--chart-bg)',
                                padding: '10px 20px',
                                borderRadius: '0px',
                                border: '1px solid var(--chart-border)',
                                marginBottom: '24px',
                                borderRadius: '8px',
                                boxShadow: '0px 1.076px 3.229px 0px rgba(24, 29, 37, 0.10)',
                                width: '100%'
                            }}
                        >
                            <Typography fontSize={19} color="var(--text-color)" fontWeight={700}>
                                Monthly Performance Comparison
                            </Typography>
                            <Box
                                sx={{
                                    width: '100%',
                                    height: '30%'
                                }}
                            >
                                <Bar data={barData} options={barOptions} style={{ width: '100%', height: '350px', padding: '20px' }} />
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                {data.map((teamData, index) => {
                    const teamName = Object.keys(teamData)[0];
                    const rows = teamData[teamName];
                    return (
                        <Box key={index} sx={{ width: '100%', padding: 2, backgroundColor: 'var(--theme-bg-light)', borderRadius: 2, marginTop: 2 }}>
                            <Box display="flex" justifyContent="space-between" alignItems="center" mb={1}>
                                <Typography variant="h6" sx={{ fontWeight: 700 }}>
                                    {teamName}
                                </Typography>
                                <Box sx={{ backgroundColor: '#f0f0f0', borderRadius: '25px', padding: '6px 20px', fontSize: '13px', textAlign: 'center', color: "#615E83", }}>
                                    {year}
                                </Box>
                            </Box>
                            <Divider sx={{
                                margin: '10px 0', // Add vertical margin
                                backgroundColor: '#E5E5EF', // Change the color of the divider
                                height: '1px', // Set the thickness of the divider
                            }}></Divider>
                            <DataGrid
                                rows={rows}
                                columns={columns}
                                className="data-grid-global-font"
                                pageSize={4}
                                sx={{
                                    border: 'none',
                                    '& .MuiDataGrid-cell': {
                                        border: 'none',
                                    },
                                    '& .MuiDataGrid-columnSeparator': {
                                        display: 'none',
                                    },
                                    '& .MuiDataGrid-withBorderColor': {
                                        borderColor: '#fff',
                                    },
                                    '& .MuiDataGrid-columnHeaders': {
                                        border: 'none',
                                        fontWeight: '500',
                                        color: '#333333',
                                        height: '38px !important', // Set the header height
                                        overflow: 'hidden'
                                    },
                                    '& .MuiDataGrid-columnHeader': {
                                        padding: '4px 8px !important', // Adjust padding to reduce height
                                        height: '45 px !important',
                                        overflow: 'hidden'
                                    },
                                    '& .MuiDataGrid-scrollbar': {
                                        display: 'none'
                                    },
                                    '& .MuiDataGrid-columnHeaderTitle': {
                                        fontWeight: '500',
                                        color: '#333333',
                                        fontSize: '16px', // Reduce font size if needed
                                        lineHeight: '1 !important',
                                    },
                                    '& .MuiDataGrid-row--borderBottom': {
                                        border: 'none !important',
                                    },
                                }}
                                hideFooter
                                rowsPerPageOptions={[4]}
                                disableSelectionOnClick
                                getRowHeight={() => 35} // Set the desired row height here
                            />


                        </Box>
                    );
                })}

            </Box>
        </Box>
    );
}
